import { isEmpty } from 'lodash';
import { useMemo } from 'react';

import { AppointmentModalData } from '../../../data/data/types';
import {
  AgendaBlockItemDataFragment,
  SlotType,
  TemplateEntryItemDataFragment,
} from '../../../data/types/api/graphql';
import { AgendaBlockListItem } from './agenda-block-list-item';

type AgendaBlockListProps = {
  healthProviderId: string | null | undefined;
  healthProfessionalId: string | null | undefined;
  date: string;
  items: AgendaBlockItemDataFragment[];
  showAppointmentModal?: (
    slotType: SlotType,
    value: AppointmentModalData | null
  ) => void;
};

export function AgendaBlockList({
  healthProviderId,
  healthProfessionalId,
  showAppointmentModal,
  date,
  ...props
}: AgendaBlockListProps) {
  const items = useMemo(
    () =>
      props.items
        .filter(option => option.template)
        .map(option => ({
          ...option,
          template: option.template as TemplateEntryItemDataFragment,
        })),
    [props.items]
  );

  if (isEmpty(items)) return null;

  return (
    <div className="agenda-appointment-block-list">
      {items.map(option => (
        <div
          key={option.template.id}
          className="agenda-appointment-block-list__item"
        >
          <AgendaBlockListItem
            showAppointmentModal={showAppointmentModal}
            compact
            healthProviderId={healthProviderId}
            healthProfessionalId={healthProfessionalId}
            date={date}
            agendaBlockItem={option}
          />
        </div>
      ))}
    </div>
  );
}
